import { ISSFBehaviorsOptions } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { createApolloClient, createApolloCache } from 'providers/ApolloProvider';
import { QUERY_settingsPageFetchOpenShifts } from 'queries';
import { OrderStatusEnum } from 'types/graphql';

interface IRequestOpenShiftsConfig {
  positionId: number;
  facilityId: number;
  orderFilter: {
    forOrders: {
      withStatus: OrderStatusEnum[];
      withCommunity: number[];
    };
  };
}

interface IRequestOpenShiftsSchema {
  positionId: string;
  facilityId: number;
  filter?: {
    byPositionId: string;
    byFacilityId: number;
  };
  orderFilter: {
    forOrders: {
      withStatus: OrderStatusEnum[];
      withCommunity: number[];
    };
  };
}

const requestOpenShiftsApolloClient = createApolloClient({ cache: createApolloCache() });

export const requestOpenShiftsConfig = ({
  positionId,
  facilityId,
  orderFilter,
}: IRequestOpenShiftsConfig): ISSFBehaviorsOptions => ({
  client: requestOpenShiftsApolloClient,
  key: 'OPEN_SHIFTS_REMOVE_POSITION_VIEW_QUERY',
  query: QUERY_settingsPageFetchOpenShifts,
  paginationType: 'InfiniteScroll',
  debounceTimeout: 500,
  payloadTransformer: (variables: IRequestOpenShiftsSchema) => {
    return {
      ...variables,
      positionId: variables.positionId,
      filter: {
        byPositionId: variables.positionId,
        byFacilityId: variables.facilityId,
      },
      orderFilter: {
        forOrders: {
          withStatus: variables.orderFilter.forOrders.withStatus,
          withCommunity: variables.orderFilter.forOrders.withCommunity,
        },
      },
    };
  },
  pageSize: 20,
  variables: {},
  schema: {
    positionId: {
      initialValue: positionId,
    },
    facilityId: {
      initialValue: facilityId,
    },
    orderFilter: {
      initialValue: orderFilter,
    },
  },
});
